import { testimonials } from "@/mocks/news";

export default function About() {
  const scrollTo = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="about" className="scroll-mt-20 overflow-hidden bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[0.95fr_1.05fr]">
          {/* 关于文案 */}
          <div>
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-quill-pen-fill" />
              About Us
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              关于吃瓜51
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              吃瓜51是一个专注聚合全网热门事件与新鲜爆料的资讯平台。我们从海量公开信息中筛选、梳理与整合，
              把最有看点的娱乐八卦、社会热点、圈内动态第一时间呈现在你面前。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-700">
              我们相信，好的吃瓜不只是围观热闹，更在于把事情讲清楚、把热度看明白。
              因此吃瓜51坚持更新快、选题准、立场稳，做你触手可及的今日热点清单。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-3">
              {[
                { i: "ri-refresh-line", t: "分钟级更新", d: "突发热点抢先" },
                { i: "ri-collage-line", t: "栏目多元", d: "娱乐社会全覆盖" },
                { i: "ri-focus-2-line", t: "专题深挖", d: "不止一个标题" },
                { i: "ri-shield-check-line", t: "理性吃瓜", d: "多方信源整合" },
              ].map((f) => (
                <div key={f.t} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <i className={`${f.i} text-xl text-primary-500`} />
                  <p className="mt-2 text-sm font-bold text-foreground-900">{f.t}</p>
                  <p className="mt-0.5 text-xs text-foreground-600">{f.d}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 口碑 */}
          <div>
            <div className="flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                <i className="ri-chat-heart-fill text-primary-500" />
                用户口碑
              </h3>
              <span className="flex items-center gap-1 text-sm text-accent-600">
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <i className="ri-star-fill" />
                <span className="ml-1 font-semibold text-foreground-800">4.9</span>
              </span>
            </div>

            <div className="mt-5 space-y-4">
              {testimonials.map((m) => (
                <blockquote
                  key={m.id}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-shadow hover:shadow-card md:p-6"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3">
                      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 font-heading text-lg font-bold text-background-50">
                        {m.avatar}
                      </span>
                      <div>
                        <p className="text-sm font-bold text-foreground-900">{m.name}</p>
                        <p className="text-xs text-foreground-600">{m.role}</p>
                      </div>
                    </div>
                    <span className="flex items-center gap-0.5 text-accent-500">
                      {Array.from({ length: m.score }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm" />
                      ))}
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                    “{m.content}”
                  </p>
                </blockquote>
              ))}
            </div>

            <button
              type="button"
              onClick={() => scrollTo("subscribe")}
              className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-background-300 bg-background-50 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200"
            >
              也来分享你的吃瓜体验
              <i className="ri-arrow-right-line text-primary-500" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}